import React from 'react';
import { Wallet, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { formatNumber } from '../../utils/constants';

export const FinancialSummaryCards = ({ cashAccountsTotal, receivablesTotal, totalAssets, payablesTotal, totalLiabilities, netWorth }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="financial-summary-cards">
      <div className="bg-emerald-50 p-4 rounded-xl border border-emerald-200">
        <div className="flex items-center gap-1 mb-1">
          <Wallet className="w-3 h-3 text-emerald-600" />
          <h3 className="text-xs font-medium text-emerald-800">Cash Accounts</h3>
        </div>
        <p className="text-xl font-bold text-emerald-700">RWF {formatNumber(cashAccountsTotal)}</p>
      </div>
      <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
        <div className="flex items-center gap-1 mb-1">
          <ArrowUpRight className="w-3 h-3 text-blue-600" />
          <h3 className="text-xs font-medium text-blue-800">Receivables</h3>
        </div>
        <p className="text-xl font-bold text-blue-700">RWF {formatNumber(receivablesTotal)}</p>
      </div>
      <div className="bg-green-50 p-4 rounded-xl border border-green-200">
        <h3 className="text-xs font-medium text-green-800 mb-1">Other Assets</h3>
        <p className="text-xl font-bold text-green-700">RWF {formatNumber(totalAssets)}</p>
      </div>
      <div className="bg-amber-50 p-4 rounded-xl border border-amber-200">
        <div className="flex items-center gap-1 mb-1">
          <ArrowDownRight className="w-3 h-3 text-amber-600" />
          <h3 className="text-xs font-medium text-amber-800">Payables</h3>
        </div>
        <p className="text-xl font-bold text-amber-700">RWF {formatNumber(payablesTotal)}</p>
      </div>
      <div className="bg-red-50 p-4 rounded-xl border border-red-200">
        <h3 className="text-xs font-medium text-red-800 mb-1">Other Liabilities</h3>
        <p className="text-xl font-bold text-red-700">RWF {formatNumber(totalLiabilities)}</p>
      </div>
      <div className={`${netWorth >= 0 ? 'bg-violet-50 border-violet-200' : 'bg-rose-50 border-rose-200'} p-4 rounded-xl border`}>
        <h3 className={`text-xs font-medium mb-1 ${netWorth >= 0 ? 'text-violet-800' : 'text-rose-800'}`}>Net Worth</h3>
        <p className={`text-xl font-bold ${netWorth >= 0 ? 'text-violet-700' : 'text-rose-700'}`}>RWF {formatNumber(netWorth)}</p>
      </div>
    </div>
  );
};
